{
  "pt": {
    "datatable": {
      "actions": {
        "bulk_action": "Ação em massa",
        "bulk_edit": "Editar em massa",
        "clear": "Limpar",
        "clear_filters": "Limpar filtros",
        "collapse_all": "Recolher tudo",
        "deselect_all": "Desmarcar tudo",
        "expand_all": "Expandir tudo",
        "select_all": "Selecionar tudo"
      },
      "import": {
        "error_row": "Linha {row}",
        "errors_description": "A importação foi cancelada porque {count} linha(s) continham erros. Nenhum registo foi importado.",
        "errors_title": "Falha na importação",
        "success": "Ficheiro importado com sucesso",
        "title": "Importar"
      },
      "labels": {
        "columns_selected": "{count} colunas selecionadas",
        "freeze_columns": "Congelar colunas",
        "freeze_rows": "Congelar linhas",
        "gridlines": "Linhas de grade",
        "group_by": "Agrupar por",
        "size": "Tamanho",
        "sticky_headers": "Cabeçalhos fixos",
        "striped_rows": "Linhas listradas",
        "toggle_columns": "Alternar colunas",
        "translation_style": "Estilo de tradução",
        "translation_mode_toolbar": "Global",
        "translation_mode_header": "Cabeçalho",
        "translation_mode_stacked": "Empilhado"
      }
    }
  }
}
